<template>
  <div>
    <!--退票弹窗-->
    <a-modal
      title="请确认您的信息"
      v-model="refundModVisible"
      wrapClassName="order-modal refund-modal"
      :okText="'确认'"
      :cancelText="'取消'"
      :closable="false"
      :width="640"
      :destroyOnClose="true"
      @ok="refundInfoOk"
    >
      <div class="refund-mod-notice">确定要提交退票申请吗？您的座位将被释放，此操作不能回退！</div>
      <template v-for="(seg, segIndex) in refundSegs">
        <div :key="segIndex" v-if="!(ifInternational?.() && airline === 'JD')">
          <div class="refund-mod-subtitle">{{seg.departureName}} - {{seg.arrivalName}} {{seg.cabinCode}}舱： 客票退改规则</div>
          <RemarkTable
            :rule="seg.remark"
            :isJJC="seg.productCode?.indexOf('JJC') >= 0"
            v-if="!ifInternational?.()"
          ></RemarkTable>
          <template v-else>
            <div class="refund-changes-detail-int" v-html="getRefundChangeFeesInt(seg)"></div>
          </template>
        </div>
      </template>
      <refund-rules-detail :ifInternational="ifInternational?.()"></refund-rules-detail>
      <!-- <div v-if="!ifInternational?.()" class="refund-mod-p" >
          <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
          <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
      </div>
      <div v-else class="refund-mod-p">
        <span class="primary-color">1.如您购买往返客票，退改费将按照去回程中更严格一方的标准收取，具体请以实际审核退改金额为准。</span><br/>
        2.因汇率等时有变动，以上手续费仅供参考，具体可退税费需人工核实，以实际审核退改金额为准。<br/>
        <template v-if="airline === '9H'">
          3.如需提交非自愿退票，请点击确认后在下一页面选择。<br>
        </template>
        <span class="primary-color">另: 儿童变更/退票手续费按照成人相应规定执行。 不占座婴儿变更/退票免收手续费。</span><br/>
      </div> -->
      <!-- <div class="refund-mod-tip">
        <div class="_tip _tip-icon">
          <l8-icon class="l8-icon" type="icon-xunhuan1"/>
        </div>
      </div> -->
    </a-modal>
    <!--退票确认弹窗-->
    <a-modal
      title="提交退票申请"
      v-model="refundApplyModVisible"
      wrapClassName="order-modal apply-modal"
      :okText="'提交'"
      :cancelText="'取消'"
      :closable="false"
      :width="640"
      :maskClosable="false"
      :confirmLoading="refundApplyLoading"
      @ok="refundApplyOk"
    >
      <a-form layout="horizontal" :form="form">
        <h4 class="apply-mod-title">退票类型</h4>
        <a-select
          class="apply-select"
          dropdownClassName="apply-dropdown"
          defaultValue="UNCONSTRAINT"
          style="width: 100%"
          @change="refundTypeChangeHandler">
          <template v-if="refundTypesFilter.length > 0">
            <a-select-option v-for="item in refundTypesFilter" :value="item.key" :key="item.key">{{item.label}}</a-select-option>
          </template>
          <template v-else>
            <a-select-option value="UNCONSTRAINT">自愿</a-select-option>
            <a-select-option value="CONSTRAINT">非自愿</a-select-option>
          </template>
        </a-select>
        <div class="apply-reason">
          <template v-if="refundType === 'CONSTRAINT'">
            <div class="apply-mod-title">退票原因</div>
            <div class="apply-radio-group">
              <a-radio-group name="applyGroup" defaultValue="UNTK" @change="refundReasonChange" v-model="refundReasonType">
                <!-- NOTE: JD - 下线"升舱改期/客票换开" -->
                <template v-if="refundReasonsFilter?.length === 0">
                  <a-radio value="CHANGE" v-if="airline !== 'JD'">升舱改期/客票换开</a-radio>
                  <a-radio value="UNTK">航班取消/延误</a-radio>
                  <!-- 病退现在不能出现在非自愿退票原因里 -->
                  <!-- <a-radio value="BINGTUI">病退</a-radio> -->
                  <a-radio value="REPEAT">重复购票</a-radio>
                  <a-radio value="OTHER">其他</a-radio>
                </template>
                <template v-else>
                  <template v-for="item in refundReasonsFilter">
                    <!-- 病退现在不能出现在非自愿退票原因里 -->
                    <a-radio v-if="item.key !== 'BINGTUI'" :value="item.key" :key="item.key">{{ item.label }}</a-radio>
                  </template>
                </template>
              </a-radio-group>
            </div>
            <template v-if="refundReasonsFilter?.length === 0">
                <div v-if="refundReasonType === 'CHANGE'">
                  <template v-if="getContentByType('CHANGE')">
                    <div v-html="getContentByType('CHANGE')"></div>
                  </template>
                  <template v-else> 请备注新出客票号，待新客票使用后原客票进行退款。 </template>
                </div>
                <div v-if="refundReasonType === 'UNTK'">
                  <template v-if="getContentByType('UNTK')">
                    <div v-html="getContentByType('UNTK')"></div>
                  </template>
                  <template v-else> 航班变动信息属实则予以全退，不符合不正常航班定义的将按自愿退票进行处理。 </template>
                </div>
                <div v-if="refundReasonType === 'BINGTUI'">
                  <template v-if="getContentByType('BINGTUI')">
                    <div v-html="getContentByType('BINGTUI')"></div>
                  </template>
                  <template v-else> 选择病退原因时，需提供病退材料。 </template>
                </div>
                <div v-if="refundReasonType === 'REPEAT'">
                  <template v-if="getContentByType('REPEAT')">
                    <div v-html="getContentByType('REPEAT')"></div>
                  </template>
                  <template v-else> 请备注重复购票票号:<br>①重复购票退座时间必须在航班计划起飞前24小时（含）前;<br>②旅客重复购买的两张客票的购票时间间隔需在24小时以内(含);<br>③在出票后24小时(含)内提出重复购票退票申请并取消航班座位，则一张客票可免手续费，其他将按自愿退票处理；票价不一致时仅免费退最后一次购买的客票。 </template>
                </div>
                <div v-if="refundReasonType === 'OTHER'">
                  <template v-if="getContentByType('OTHER')">
                    <div v-html="getContentByType('OTHER')"></div>
                  </template>
                </div>
            </template>
            <template v-else>
              <div v-html="refundReasonsFilterItem?.content"></div>
            </template>
          </template>
          <template v-if="refundType === 'UNCONSTRAINT'">
            <template v-if="refundTypesFilter?.length === 0">
              <template v-if="getContentByType('UNCONSTRAINT')">
                <div v-html="getContentByType('UNCONSTRAINT')"></div>
              </template>
              <div v-else>尊敬的用户，您提交的自愿退票将按照航司多等级舱位管理规定收取手续费。</div>
              <!-- <div>温馨提示: </div>
              <div>购票日期为2021年1月27日0时前，乘机日期在1月28日-2月3日，航班起飞前退票免收退票手续费；乘机日期在2月4日至3月8日，航班起飞前7天退票免收退票手续费。</div>
              <div>在2020年1月28日（不含）之前购买了2020年1月1日（含）至2020年3月31日（含）间起飞的祥鹏航空（8L）国内航班机票的旅客，如您暂不出行，可在购票1年内免费变更一次至2021年1月31日（含）前的同航段同舱位航班，您可在确定行程后，打开“旅行服务—不正常航班/疫情影响客票改期”输入相应的客票号进行办理。</div> -->
            </template>
            <template v-else>
               <div v-html="refundTypesFilterItem?.content"></div>
            </template>
          </template>
          <template v-if="refundType === 'BINGTUI'">
            <template v-if="refundReasonBingtuiItem?.content">
              <div v-html="refundReasonBingtuiItem?.content"></div>
            </template>
            <template v-else>
              <template v-if="getContentByType('BINGTUI')">
                <div v-html="getContentByType('BINGTUI')"></div>
              </template>
              <template v-else> 选择病退原因时，需提供病退材料。 </template>
            </template>
          </template>
        </div>
        <div class="apply-passenger" v-if="refundType === 'BINGTUI'">
          <div class="apply-mod-title">退票旅客</div>
          <div class="apply-passenger-block">
            <div class="apply-passenger-item" v-for="(sItem, sIndex) in selectedPassengers" :key="sItem.id">
              <div class="apply-passenger-name">{{ sItem.passenger.fullName }}</div>
              <a-radio-group name="personTypeGroup" v-model="sItem.personType" @change="personTypeChange($event, sIndex)">
                <a-radio value="self" :disabled="sItem.selfDisabled">病患本人</a-radio>
                <a-radio value="accompany" :disabled="sItem.accompanyDisabled">陪护人员</a-radio>
              </a-radio-group>
            </div>
          </div>
        </div>
        <div class="apply-refund-files" v-if="refundType === 'BINGTUI' || (refundType !== 'UNCONSTRAINT' && refundReasonType !== 'UNTK')">
          <div v-if="refundType === 'BINGTUI'">
            <div v-for="(sItem, sIndex) in selectedPassengers" :key="sIndex">
              <div v-if="sItem.personType === 'self' || sItem.personType === 'accompany'">
                <div class="refund-files-passenger">{{ sItem.personType === 'self' ? '病患本人' : '陪护人员' }}：{{ sItem.passenger.fullName }}</div>
                <div class="refund-files-cert">
                  <div>请选择要上传的购票证件：</div>
                  <a-select
                    class="cert-select"
                    :defaultValue="sItem.uploadCertType"
                    @change="certTypeChange($event, sIndex)"
                  >
                    <a-select-option value="idca">身份证</a-select-option>
                    <a-select-option value="pp">护照</a-select-option>
                    <a-select-option value="hr">户口本</a-select-option>
                  </a-select>
                </div>
                <div v-for="(pItem, pIndex) in sItem.proofOfIllnessList" :key="pIndex">
                  <div class="apply-mod-title">
                    <span v-if="pItem.require">*</span>{{ pItem.title }}
                  </div>
                  <FileUpload
                    :key="`${sItem.personType}-${sIndex}-${pIndex}-${pItem.type}`"
                    :subText="pItem.sub"
                    :fileLimit="pItem.filesLimit"
                    :seller="sellerCode"
                    :sellerChannel="sellerChannel"
                    @setFileList="getIllnessFileList($event, sItem, pIndex, pItem.type)"
                  ></FileUpload>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="apply-mod-title">附件上传</div>
            <FileUpload :seller="sellerCode" :sellerChannel="sellerChannel" @setFileList="getFileList"></FileUpload>
          </div>
        </div>
        <template v-if="isOfflinePayment">
          <h4 class="apply-mod-title mt-20">收款人信息</h4>
          <a-form-item
            label="持卡人"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
          >
            <span>{{ userInfo.fullName }}</span>
          </a-form-item>
          <a-form-item
            label="银行卡号"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
            required
          >
            <a-input
              v-model="bankNo"
              placeholder="请输入银行卡号"
              size="large"
              v-decorator="[
                'bankNo',
                {
                  rules: [{ validator: handleFieldValidate }],
                  validateTrigger: 'blur',
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            label="联系手机"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
          >
            <span>{{ userInfo.phone | codeMask }}</span>
          </a-form-item>
          <a-form-item
            label="验证码"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
          >
            <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
            </user-slider-captcha>
          </a-form-item>
          <a-form-item
            label="手机验证码"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
          >
            <user-verification-code placeholder="请输入手机验证码" size="large" actionText="获取手机验证码" :areaCode="countryCode" :smsType="17" :value="userInfo.phone" :token="token" handlerErrorBySelf @change="onVerificationCodeChange" @error="onVerificationCodeError">
            </user-verification-code>
          </a-form-item>
          <!-- <a-form-item
            label="验证码"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
            required
          >
            <l8-imgcaptcha
              v-decorator="[
                'captcha',
                {
                  rules: [{ validator: handleFieldValidate }],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
              @blur="onCaptchaChange"
            ></l8-imgcaptcha>
          </a-form-item>
          <a-form-item
            label="手机验证码"
            class="apply-item"
            :label-col="{ span: labelWidth }"
            :wrapper-col="{ span: wrapWidth }"
            required
          >
            <l8-mobileverification
                size="large"
                :countryCode="countryCode"
                :phone="userInfo.phone"
                :captcha="phoneCaptcha"
                v-model="validateCode"
                placeholder="手机验证码"
                v-decorator="[
                  'phoneCode',
                  {
                    rules: [{ validator: handleFieldValidate }],
                    validateTrigger: 'change'
                  }
                ]"
              ></l8-mobileverification>
          </a-form-item> -->
          <div class="refund-tips" v-if="refundSetting?.content">
            {{ refundSetting?.content  }}
          </div>
          <div v-else>
            为保证资金安全，根据相关法律法规，退款仅限退回登录用户本人,请确保正确填写收款信息；退款仅限一次，如涉及多渠道重复退款等套利行为，将追究相关责任。
          </div>
        </template>
        <div class="apply-reason-text">
          <a-textarea v-model="refundReason" placeholder="备注" :rows="4"/>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { get, groupBy, each, map, chain, cloneDeep, countBy, find, some, every, uniqBy } from 'lodash'
import storage from '@/assets/js/storage'
import RemarkTable from '@/components/passenger-seg-list/module/remark-table.vue'
import FileUpload from '@/components/file-upload'
import { refundOrderV2 } from '@/apis/order'
import { eventTrack } from '@/apis/common'
import getAppInfo from '@/utils/from'
import { validate } from '@/assets/js/validate'
import Observer from '@/assets/js/observer'
import { filterRegion } from '@/assets/js/util'

import refundRulesDetail from '@/components/benefits/refund-rules-detail'

const passengerTypeSort = ['ADULT', 'CHILD', 'INFANT']
const { airline = '', cms = {} } = window.__MICRO_ROOT__
const { value: userInfo } = storage.getItem('USER_CENTER_INFO') || {}
const illnessList = [
  {
    title: '上传身份证',
    sub: '请上传购票证件原件作为退票凭证',
    type: 'idca',
    filesLimit: 2,
    require: true,
    files: []
  },
  {
    title: '上传护照',
    sub: '请上传购票证件原件作为退票凭证',
    type: 'pp',
    filesLimit: 5,
    require: true,
    files: []
  },
  {
    title: '上传户口本',
    sub: '请上传购票证件原件作为退票凭证',
    type: 'hr',
    filesLimit: 5,
    require: true,
    files: []
  },
  {
    title: '上传诊断证明',
    type: 'diagnosis',
    filesLimit: 9,
    require: true,
    files: []
  },
  {
    title: '上传病历',
    type: 'case',
    filesLimit: 9,
    require: true,
    files: []
  },
  {
    title: '上传票据',
    type: 'bill',
    filesLimit: 9,
    files: []
  },
  {
    title: '上传医疗发票',
    type: 'medi',
    filesLimit: 9,
    files: []
  }
]

export default {
  name: 'DetailRefund',
  props: {
    detail: {
      type: Object
    },
    refundSetting: {
      type: Object
    },
    selectedSeg: {
      type: Array
    },
    isOfflinePayment: {
      type: Boolean,
      default: false
    },
    sellerCode: String,
    sellerChannel: String
  },
  data () {
    return {
      refundSegs: [],
      refundType: 'UNCONSTRAINT',
      refundReasonType: 'UNTK',
      refundReason: '',
      // 退票弹窗控制
      refundModVisible: false,
      refundApplyModVisible: false,
      refundApplyLoading: false,
      fileList: [],
      appInfo: getAppInfo(),
      airline,
      refundTypes: [],
      refundReasons: [],
      refundReasonsUpgrade: [],
      refundSpecialTips: '',
      proofOfIllnessList: illnessList,
      form: this.$form.createForm(this),
      labelWidth: 4,
      wrapWidth: 20,
      userInfo,
      bankNo: '',
      token: '',
      countryCode: '86',
      validateCode: '', // 手机验证码
      phone: '', // 发送手机验证码的手机号码
      phoneCaptcha: false, // 手机号码校验结果
      selectedPassengers: []
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  created () {
    this.getCmsData()
  },
  computed: {
    refundTypesFilter () {
      const refundTypes = (this.refundTypes || []).filter((item) =>
        filterRegion(item, this.ifInternational?.(), 'type') && item.show
      )
      return refundTypes
    },
    refundReasonsFilter () {
      return (this.refundReasonsUpgrade || []).filter((item) =>
        filterRegion(item, this.ifInternational?.()) && item.show
      )
    },
    refundReasonsFilterItem () {
      return this.refundReasonsFilter.find((item) => {
        return item.key === this.refundReasonType
      })
    },
    refundReasonBingtuiItem () {
      return this.refundReasonsFilter.find((item) => {
        return item.key === 'BINGTUI'
      })
    },
    refundTypesFilterItem () {
      return this.refundTypesFilter.find((item) => {
        return item.key === this.refundType
      })
    }
  },
  watch: {
    selectedSeg (newValue) {
      if (newValue) {
        // 病退时按乘客而不是按航段上传文件
        this.selectedPassengers = uniqBy(newValue, 'passenger.fullName')
      }
    },
    refundApplyModVisible: {
      handler: function (val) {
        if (val) {
          this.resetPassengerUploadFileInfo()
        }
      }
    }
  },
  methods: {
    resetPassengerUploadFileInfo () {
      this.selectedPassengers.forEach(item => {
        this.$set(item, 'personType', undefined)
        this.$set(item, 'accompanyDisabled', true)
        this.$set(item, 'uploadCertType', 'idca')
      })
    },
    async getCmsData () {
      const pageCmsData = (await cms.getPageData()) ?? {}
      this.refundTypes = get(pageCmsData, 'refund-types.list') ?? []
      this.refundReasons = get(pageCmsData, 'refund-reasons.list') ?? []
      this.refundReasonsUpgrade = get(pageCmsData, 'refund-reasons-upgrade.list') ?? []
      this.refundSpecialTips = get(pageCmsData, 'refund-special-tips.content') ?? []
      if (this.refundReasons?.length > 0) {
        this.getRefundReasonsContent()
      }
      if (this.refundReasonsUpgrade?.length > 0) {
        this.getRefundReasonsUpgradeContent()
      }
      if (this.refundTypes?.length > 0) {
        this.getRefundTypesContent()
      }
    },

    async getRefundTypesContent () {
      const { refundTypes } = this
      let contentIdList = []
      // 获取所有的id推入contentIdList
      for (const item of refundTypes) {
        contentIdList.push(item.moduleId)
      }
      const contentResult = (await cms?.fetchItems(contentIdList)) ?? {}
      // 对应id去分配文案
      for (let index = 0; index < refundTypes.length; index++) {
        refundTypes[index].content = contentResult[refundTypes[index]?.moduleId]?.content
      }
    },

    async getRefundReasonsUpgradeContent () {
      const { refundReasonsUpgrade } = this
      let contentIdList = []
      // 获取所有的id推入contentIdList
      for (const item of refundReasonsUpgrade) {
        contentIdList.push(item.moduleId)
      }
      const contentResult = (await cms?.fetchItems(contentIdList)) ?? {}
      // 对应id去分配文案
      for (let index = 0; index < refundReasonsUpgrade.length; index++) {
        refundReasonsUpgrade[index].content = contentResult[refundReasonsUpgrade[index]?.moduleId]?.content
      }
    },
    async getRefundReasonsContent () {
      let contentIdList = []
      // 获取所有的id推入contentIdList
      for (const item of this.refundReasons) {
        for (const contentMsg of item.contents) {
          contentIdList.push(contentMsg.id)
        }
      }
      const contentResult = (await cms?.fetchItems(contentIdList)) ?? {}
      // 对应id去分配文案
      for (const item of this.refundReasons) {
        for (const contentMsg of item.contents) {
          contentMsg.content = contentResult[contentMsg.id].content
        }
      }
    },
    getContentByType (type) {
      const { refundReasons } = this
      return refundReasons[0]?.contents?.find(item => { return item.title === type })?.content
    },
    startRefund () {
      if (this.detail.changes.length) { // 有改期时，不提示退改规则
        this.refundApplyModVisible = true
      } else {
        this.refundModVisible = true
      }
      this.fetchRefundModal()
    },
    fetchRefundModal () {
      const refundSegs = groupBy(JSON.parse(JSON.stringify(this.selectedSeg)), (seg) => {
        // 基于中转场景，优化分组 key 的选择
        return `${seg.departureCode}-${seg.arrivalCode}`
      })
      const segments = []

      for (const key in refundSegs) {
        segments.push(refundSegs[key].sort(function (a, b) {
          const aIdx = passengerTypeSort.indexOf(a.passenger.type)
          const bIdx = passengerTypeSort.indexOf(b.passenger.type)

          return aIdx - bIdx
        })[0])
      }

      each(segments, (seg) => {
        if (seg.refundChangeFee) {
          seg.remark = seg.refundChangeFee
        } else {
          this.refundApplyModVisible = true
          this.refundModVisible = false
        }
      })

      this.refundSegs = segments
    },
    refundInfoOk () {
      this.refundModVisible = false
      this.refundApplyModVisible = true
    },
    refundApplyOk () {
      const observer = new Observer()

      if (this.refundType === 'BINGTUI') {
        if (some(this.selectedPassengers, s => !s.personType)) {
          this.$error({
            title: '温馨提示',
            okText: '知道了',
            content: '请选择病退退票旅客类型'
          })
          return
        }
        const fileflag = some(this.selectedPassengers, sItem => {
          return some(sItem.proofOfIllnessList || [], pItem => {
            return pItem.require ? !pItem.files.length : false
          })
        })
        if (fileflag) {
          this.$error({
            title: '温馨提示',
            okText: '知道了',
            content: '请上传病退相关文件图片'
          })
          return
        }
      }

      if (airline === 'JD' && this.refundReasonType === 'REFUSE' && this.fileList.length === 0) {
        this.$error({
          title: '温馨提示',
          okText: '知道了',
          content: '请上传相关文件图片'
        })
        return
      }

      if (userInfo && (userInfo.userType === 1 || userInfo.userType === 2)) {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            // 代理人
            this.$info({
              title: '温馨提示',
              content: '尊敬的用户，由于权限问题，部分退票系统无法自动清位，请在提交退票后检查编码状态，若未清位请手工清位，避免出现虚耗情况，谢谢您的配合。',
              okText: '确认',
              onOk: () => {
                this.applyRefund()
              }
            })
          })
        })
      }

      if (airline === 'JD' && this.ifInternational?.()) {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            this.$confirm({
              title: '温馨提示',
              content: '仅支持未变更过的客票，一经确认提交退票，系统将执行取消所有未使用航段的订座及退票操作，客票将无法恢复。退票手续费以最终审核为准。如您已值机，请取消值机后再提交退票，否则手续费将按照误机标准计算。已使用的航段将无法退票退费。',
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                this.applyRefund()
              },
              onCancel: () => {
                reject(new Error())
              }
            })
          })
        })
      }

      if (airline === '8L' && this.refundType === 'CONSTRAINT') {
        const { appInfo } = this
        observer.add(() => {
          return new Promise((resolve, reject) => {
            const h = this.$createElement
            this.$confirm({
              title: '温馨提示',
              content: h('div', {}, [
                h('span', '提交非自愿退票时，将扣减客票已使用航段对应票款。'),
                h('span', { style: { color: '#da2129' } }, `页面展示的退改费用为系统估算，仅供参考，具体费用以实际审核结果为准，`),
                h('span', `如遇问题请致电${appInfo.hotline}咨询了解。点击同意并继续将为你提交退票审核并立即取消座位，`),
                h('span', { style: { color: '#da2129' } }, `如审核不通过将按照自愿退票规则收取退票手续费，该操作不可撤销，请谨慎操作。`)
              ]),
              okText: '同意并继续',
              cancelText: '取消',
              onOk: () => {
                this.applyRefund()
              },
              onCancel: () => {
                reject(new Error())
              }
            })
          })
        })
      }

      observer.complete = () => {
        this.applyRefund()
      }

      observer.start()
    },
    async handleEventTrack () {
      try {
        await eventTrack({
          name: 'flight_refund_track',
          description: '机票退票提交弹窗确认',
          page_name: '订单详情'
        })
      } catch (err) {
        console.error(err, 'error：机票退票提交记录失败')
      }
    },
    async applyRefund () {
      const { bankNo, validateCode, sellerCode, sellerChannel } = this
      const ifInternational = this.ifInternational?.() ?? false
      let refundSegIds = map(this.selectedSeg, (seg) => (seg.id))
      // 退票原因传中文
      // let refundReasonTypeMap = {
      //   'CHANGE': '升舱改期/客票换开',
      //   'UNTK': '航班取消/延误 ',
      //   'BINGTUI': '病退',
      //   'REPEAT': '重复购票',
      //   'OTHER': '其他'
      // }

      // 枚举映射，使用中台字段
      const refundReasonTypeMap = {
        'CHANGE': 'EXCHANGE',
        'UNTK': 'UNDELAY',
        'BINGTUI': 'ILLNESS',
        'REPEAT': 'REPEAT',
        'OTHER': 'OTHER'
      }

      const constraintReason = this.refundType === 'CONSTRAINT' ? refundReasonTypeMap[this.refundReasonType] : this.refundType === 'BINGTUI' ? refundReasonTypeMap[this.refundType] : ''
      const params = {
        constraintReason,
        'orderId': this.detail.orderId,
        'orderNo': this.detail.orderNo,
        'orderItemServiceDetailIds': refundSegIds,
        'refundType': this.refundType === 'BINGTUI' ? 'CONSTRAINT' : this.refundType,
        'remark': this.refundReason,
        'type': 'TICKET',
        ifInternational,
        seller: sellerCode,
        sellerChannel
      }

      if (bankNo) {
        params.account = {
          bankNo,
          name: userInfo?.fullName,
          smsCode: validateCode
        }
      }

      if (this.selectedSeg?.length > 0) {
        params.orderItemServices = chain(this.selectedSeg)
          .groupBy('serviceKey')
          .toPairsIn()
          .map(function (item) { return { 'serviceKey': item[0], 'detailIDList': map(item[1], 'id') } })
          .value()
      }

      // 添加附件入参
      const { userId } = userInfo
      if (this.refundType === 'BINGTUI') {
        // 给同一名乘客的往返程航段挂上相同的上传文件
        const realSelectedSegs = this.selectedSeg.map(seg => {
          this.selectedPassengers.forEach(sPassenger => {
            if (sPassenger.passenger.fullName === seg.passenger.fullName) {
              seg.proofOfIllnessList = sPassenger.proofOfIllnessList
              seg.personType = sPassenger.personType
            }
          })

          return seg
        })
        const refundDetailExt = []
        const passengerNames = []
        const refundUpLoadFilesDTOList = []
        realSelectedSegs.forEach(sItem => {
          const { id, proofOfIllnessList, personType, issCode, ticketNo, passenger } = sItem
          const refundDetailExtItem = {
            detailId: id,
            serviceType: 'TICKET',
            attachmentType: personType
          }
          const relAttachmentKeys = []
          const uploadFiles = []
          proofOfIllnessList.forEach(pItem => {
            const items = pItem.files.map(({ response }, index) => {
              if (response) {
                const { filePath, fileName, bizType } = response
                const key = `${issCode}-${ticketNo}-${pItem.type}-${index}`
                return {
                  key,
                  fileName,
                  filePath,
                  bizType,
                  createUser: userId
                }
              } else {
                return null
              }
            }).filter(item => item)
            relAttachmentKeys.push(items.map(i => i.key))
            uploadFiles.push(items)
          })
          // 过滤掉重复的往返程上传文件
          if (!passengerNames.includes(passenger.fullName)) {
            passengerNames.push(passenger.fullName)
            refundUpLoadFilesDTOList.push(uploadFiles.flat())
          }

          refundDetailExt.push({
            ...refundDetailExtItem,
            relAttachmentKeys: relAttachmentKeys.flat()
          })
        })

        params.refundUpLoadFilesDTOList = refundUpLoadFilesDTOList.flat()
        params.refundDetailExt = refundDetailExt
      } else {
        const { fileList } = this
        if (fileList && fileList.length) {
          params.refundUpLoadFilesDTOList = fileList.map(({ response }) => {
            if (response) {
              const { filePath, fileName, bizType } = response
              return {
                fileName,
                filePath,
                bizType,
                createUser: userId
              }
            } else {
              return null
            }
          }).filter(item => item)
        }
      }

      // 退票打点记录
      this.handleEventTrack()

      this.refundApplyLoading = true
      console.log('params >>>> ', params)
      refundOrderV2(params).then((res) => {
        this.refundApplyLoading = false
        this.refundApplyModVisible = false
        // NOTE: JD - 军警残退票需要弹窗提示
        if (airline === 'JD') {
          const { selectedSeg, refundSpecialTips } = this
          const isSpecial = selectedSeg.findIndex(seg => { return seg.productCode === 'PJC1' })
          if (isSpecial >= 0) {
            this.refundApplyModVisible = false
            this.$info({
              title: '温馨提示',
              content: (h) => h('div', {
                domProps: {
                  innerHTML: refundSpecialTips
                }
              }),
              okText: '确认',
              onOk: () => {
                this.$message.success('退票成功，正在刷新页面。')
                setTimeout(function () {
                  window.location.reload()
                }, 2000)
              }
            })
            return false
          }
        }
        this.$message.success('退票成功，正在刷新页面。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      }).catch((error) => {
        this.refundApplyLoading = false
        this.refundApplyModVisible = false
        this.$message.error(error.message || '退票失败，请稍候重试。')
      })
    },
    refundTypeChangeHandler (value) {
      this.refundType = value
    },
    refundReasonChange (e) {
      this.fileList = []
      this.selectedPassengers.forEach(sItem => {
        sItem?.proofOfIllnessList?.forEach(pItem => {
          pItem.files = []
        })
      })
    },
    getIllnessFileList (files, sItem, pIndex, type) {
      if (every(files, { status: 'done' })) {
        const { proofOfIllnessList } = sItem
        let currentFiles = cloneDeep(proofOfIllnessList[pIndex].files)
        if (files && files.length) {
          const fileList = cloneDeep(files)
          fileList.forEach((fileItem) => {
            fileItem.response && (fileItem.response.bizType = type)
            fileItem.uploadType = type
          })
          currentFiles = fileList
        } else {
          currentFiles = []
        }
        sItem.proofOfIllnessList = proofOfIllnessList.map(p => {
          return p.type === type ? { ...p, files: currentFiles } : p
        })
      }
    },
    getFileList (files) {
      this.fileList = files
    },
    personTypeChange (e, index) {
      const { selectedPassengers } = this
      this.$set(selectedPassengers[index], 'personType', e.target.value)
      const countPersonTypes = countBy(selectedPassengers, 'personType')
      const { self, accompany } = countPersonTypes
      if (self && accompany) {
        // 当前病患与陪护比例为 1:5
        const halfAccompany = accompany / 5
        if (halfAccompany < self) {
          // 还可添加陪护时
          selectedPassengers.forEach(item => {
            // 所有人可转变为陪护
            if (!item.personType || item.personType === 'self') {
              item.accompanyDisabled = false
            }
            // 若最多只能再添加一名陪护时，不可将病患改为陪护
            if (self - halfAccompany <= 1 && item.personType === 'self') {
              item.accompanyDisabled = true
            }
          })
        } else {
          selectedPassengers.forEach(item => {
            if (!item.personType || item.personType === 'self') {
              item.accompanyDisabled = true
            }
          })
        }
      } else if (self && !accompany) {
        selectedPassengers.forEach(item => {
          item.accompanyDisabled = false
          // 只有一名病患存在时，该病患不可改为陪护
          if (self === 1 && item.personType === 'self') {
            item.accompanyDisabled = true
          }
        })
      }

      // 设置需要上传的文件
      if (selectedPassengers[index].personType) {
        this.setPassengerProofOfIllnessList(index, selectedPassengers[index].uploadCertType)
      }
    },
    certTypeChange (val, index) {
      const { selectedPassengers } = this
      this.$set(selectedPassengers[index], 'uploadCertType', val)
      this.setPassengerProofOfIllnessList(index, val)
    },
    setPassengerProofOfIllnessList (index, type) {
      const { selectedPassengers, proofOfIllnessList } = this
      const item = find(proofOfIllnessList, { type })
      const currentPassenger = selectedPassengers[index]
      const copyList = currentPassenger?.proofOfIllnessList && currentPassenger.proofOfIllnessList.length > 1 ? currentPassenger.proofOfIllnessList.slice(1) : proofOfIllnessList.slice(3)
      const restList = currentPassenger.personType === 'self' ? copyList : []
      const list = [item, ...restList]
      this.$set(selectedPassengers[index], 'proofOfIllnessList', list)
    },
    getRefundChangeFeesInt (seg) {
      return seg.intTicketRuleText?.replaceAll('\n', '<br>')
    },
    onCaptchaChange (value) {
      this.phoneCaptcha = !!value
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      validate('ticket-refund', formValues, rule.fullField).then(
        ({ valid, errors }) => {
          if (valid) {
            callback()
          } else {
            callback(errors[0].message)
          }
        }
      )
    },
    onCaptchVerify (value) {
      this.token = value
    },
    onVerificationCodeChange (value) {
      this.validateCode = value
    },
    onVerificationCodeError (err) {
      this.$message.error({
        content: err.message,
        centered: true
      })
    }
  },
  components: {
    RemarkTable,
    FileUpload,
    refundRulesDetail
  }
}
</script>

<style lang="less">
.mt-20 {
  margin-top: 20px;
}

.has-error .ant-form-explain {
  margin-top: 4px;
}

/*订单弹窗样式*/
.order-modal {
  /*退票弹窗*/
  .refund-tips {
    font-size: 14px;
    color: @primary-color;
    margin-top: 10px;
  }

  &.refund-modal {
    .refund-mod-notice {
      font-size: 16px;
      font-weight: 700;
      color: @primary-color;
      margin: 0 0 20px;
      text-align: center;
    }

    .refund-mod-subtitle {
      font-size: 16px;
      margin: 10px 0;
      text-align: center;
    }

    .refund-mod-p {
      margin: 10px 0;
    }

    .refund-mod-tip {
      display: table;
      ._tip {
        display: table-cell;

        &._tip-icon {
          vertical-align: top;
          padding-right: 10px;
        }
      }
    }
  }

  /*退票类型弹窗*/
  &.apply-modal {
    font-size: 12px;

    .apply-mod-title {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;
      span {
        color: red;
      }
    }

    .apply-reason {
      padding: 15px 0;
    }

    .apply-passenger-item {
      display: flex;
      margin-bottom: 10px;
      .apply-passenger-name {
        margin-right: 30px;
        min-width: 200px;
      }
    }

    .apply-radio-group {
      padding: 5px 0 15px;

      .ant-radio-wrapper {
        font-size: 12px;
      }
    }

    .apply-reason-text {
      .ant-input {
        font-size: 12px;
      }
    }

    .ant-select.apply-select {
      font-size: 12px;

      .ant-select-selection {
        &.ant-select-selection--single {
          height: 42px;
        }
      }

      .ant-select-selection__rendered {
        line-height: 40px;
      }
    }

    .apply-refund-files {
      .refund-files-passenger {
        color: @primary-color;
      }
      .refund-files-cert {
        display: flex;
        align-items: center;
        .cert-select {
          width: 200px;
        }
      }
      .apply-mod-title {
        margin-top: 10px;
      }
      .upload-tips {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
